import { DataService } from "@/services/data";
import { RouteObject } from "react-router-dom";
import { PaginatedResponse } from "@/types/common";
import { FundingOrganismType } from "@/types/content/funding_organism";
import { ProfessionType } from "@/types/content/profession";
import { ProductThemeType } from "@/types/content/product_theme";

const EdumiamRoute: RouteObject = {
    path: "edumiam",
    children: [
        {
            index: true,
            async lazy() {
                let { EdumiamPage } = await import("@/pages/content/edumiam/index");
                return { Component: EdumiamPage };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                const professions = (await DataService.client.url(`/content/professions/?edumiam=1&page_size=1000`).get().json()) as PaginatedResponse<ProfessionType>;
                const funding_organisms = (await DataService.client.url(`/content/funding_organisms?page_size=1000`).get().json()) as PaginatedResponse<FundingOrganismType>;

                url.searchParams.set("domain", "edumiam");
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "8");
                url.searchParams.set("is_active", "1");

                const product_themes = (await DataService.client
                    .url(`/content/product_themes/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json()) as PaginatedResponse<ProductThemeType>;

                return {
                    professions: professions.results.sort((a, b) => a.name.localeCompare(b.name)),
                    funding_organisms: funding_organisms.results.sort((a, b) => a.name.localeCompare(b.name)),
                    product_themes
                };
            }
        },
        {
            id: "edumiam-detail",
            path: ":id",
            async lazy() {
                let { EdumiamDetailPage } = await import("@/pages/content/edumiam/detail");
                return { Component: EdumiamDetailPage };
            },
            loader: async ({ params }) => {
                const id = params.id;
                const product_theme = (await DataService.client.url(`/content/product_themes/${id}/`).get().json()) as ProductThemeType;
                return { product_theme };
            }
        }
    ]
};
export default EdumiamRoute;
